export class Client {
    constructor(
        public id?: number,
        public name?: string) { }
}